import { Th } from './Table';

export type AdminSortId = 'last_seen' | 'first_seen' | 'created' | 'updated';

type Props = {
  sortId: AdminSortId;
  label: string;
  active: AdminSortId;
  direction: 'asc' | 'desc';
  onClick: (sortId: AdminSortId) => void;
};

export function SortTh({ sortId, label, active, direction, onClick }: Props) {
  const isActive = active === sortId;
  return (
    <Th>
      <button
        type="button"
        className="inline-flex items-center gap-1 text-left hover:text-gray-900"
        onClick={() => onClick(sortId)}
      >
        {label}
        {isActive ? (direction === 'desc' ? ' ↓' : ' ↑') : ''}
      </button>
    </Th>
  );
}
